export default __webpack_public_path__ + "static/189-cd27bfe60fc0737a785be9dfd6fbb00a.gif";